// extracted by mini-css-extract-plugin
module.exports = {"loading-spinner":"_3vZhxK73jqEHmgXE5rMtJs"};